import React from 'react';
import './indexHolder.css'

function C2wSuperxJourneyIndexHolder( { index } ) {
  return (
    <div className='C2w_hexagone'>
      {index}
    </div>
  )
}

export default C2wSuperxJourneyIndexHolder;
